var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-1 pb-2 row"},[_c('div',{staticClass:"col text-center"},[_c('small',[_c('a',{staticClass:"text-danger",attrs:{"href":"javascript:;"},on:{"click":_vm.onOpenReportPlayerRequested}},[_vm._v("Report this player")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }